import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { PreviewSection } from '../components/PreviewSection';
import { ResultsSection } from '../components/ResultsSection';
import { BonusSection } from '../components/BonusSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PurchaseSection } from '../components/PurchaseSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { PurchaseNotification } from '../components/PurchaseNotification';
export function LandingPage() {
  return <main className="min-h-screen font-sans text-gray-900 bg-white overflow-x-hidden" data-id="element-512">
      <Hero data-id="element-513" />
      <ProblemSection data-id="element-514" />
      <SolutionSection data-id="element-515" />
      <PreviewSection data-id="element-516" />
      <ResultsSection data-id="element-517" />
      <BonusSection data-id="element-518" />
      <PurchaseSection data-id="element-519" />
      <GuaranteeSection data-id="element-520" />
      <TestimonialsSection data-id="element-521" />
      <FAQSection data-id="element-522" />
      <PurchaseNotification data-id="element-523" />

      {/* Footer */}
      <footer className="bg-blue-900 text-white py-8 px-4 text-center" data-id="element-524">
        <p className="text-lg font-medium text-blue-200 mb-2" data-id="element-525">
          Abrís el archivo. Das la clase. El año está resuelto.
        </p>
        <p className="text-blue-300/80 text-sm" data-id="element-526">
          © 2026 Teoría de las Organizaciones 360. Todos los derechos
          reservados.
        </p>
      </footer>
    </main>;
}